export const BILLING_STRATEGY_CHOICES = [
  { id: "SUBSCRIPTION", name: "SUBSCRIPTION" },
  { id: "LIFETIME", name: "LIFETIME" },
];
